import { Organization } from 'models/organization';
import { OrderInputBase, Participants } from './shared';
import { RestorationInput } from './restoration-input';

/** The simple flow edits the restorations it sends: one restoration per added construction, however many teeth. */
export type SimpleOrderInput = OrderInputBase & {
    /** DD-3473: the producing lab (formerly `lab`). */
    supplier?: Organization;
    restorations: RestorationInput[];
    participants: Participants;
    isWhiteLabeled: boolean;
};

export enum SimpleCategory {
    FIXED = 'FIXED',
    REMOVABLE = 'REMOVABLE',
}

export enum SimpleSubCategory {
    SINGLE_CROWN = 'SINGLE_CROWN',
    BRIDGE = 'BRIDGE',
    POST = 'POST',
    IMPLANT_CROWN = 'IMPLANT_CROWN',
    IMPLANT_BRIDGE = 'IMPLANT_BRIDGE',
    OTHER = 'OTHER',
    COMPLETE_DENTURE = 'COMPLETE_DENTURE',
    PARTIAL_DENTURE = 'PARTIAL_DENTURE',
    TEMPORARY_DENTURE = 'TEMPORARY_DENTURE',
    BITETRAY = 'BITETRAY',
    OTHER_REMOVABLE = 'OTHER_REMOVABLE',
}

export type SimpleConstructionProperty = {
    material: string;
    otherMaterial: string;
    shade: string;
    color: string;
    colorSampling: boolean;
    design: string;
    implantSteps: string;
    dentureSteps: string;
    ponticDesign: string;
    contactType: string;
    retainment: string;
    occlusion: string;
    softInside: boolean;
};
